// extracted by mini-css-extract-plugin
export default {"AppFooter":"AppFooter_AppFooter__05Iuk","AppFooterContent":"AppFooter_AppFooterContent__zxkE9","Links":"AppFooter_Links__HstAD","CC":"AppFooter_CC__60pkn"};